export default function Center( props ) {
	return <>
		<div className="main" onClick={ props.onClick } style={ props.mainStyle }  >
	        <div className="margin-left" style={ props.marginStyle } />
	        <div className="center" style={ props.style } >
	        	{ props.children }
	        </div>
	        <div className="margin-right" style={ props.marginStyle } />
		</div>
	</>
}

